import { Fragment, useContext } from "react";
import { ArticleCardContext } from "..";
import { ArticleProps } from "../../../../redux/slices/article/Article";
import { AudioPlayer } from "../../AudioPlayer";
import { PollContent } from "../../PollContent";
import { RateContent } from "../../RateContent";
import { VideoPlayer } from "../../VideoPlayer";
import { TextContent } from "./TextContent";

export const renderContent = (props: ArticleProps.Content) => {
  switch (props?.content_type_desc ?? "") {
    case "image":
      return undefined;
    case "video":
      const {
        duration,
        description: videoDescription,
        title: videoTitle,
      } = (props as ArticleProps.WithVideoContent).content_data;
      return (
        <VideoPlayer
          video_id={props.content_id}
          video_title={videoTitle}
          video_description={videoDescription}
          duration={duration}
          isViewOnly={false}
        />
      );
    case "audio":
      const {
        description,
        audio_path,
        title,
        image_id,
        post_id,
        background_type,
        background_value,
      } = (props as ArticleProps.WithAudioContent).content_data;
      return (
        <AudioPlayer
          {...{
            audio_description: description,
            audio_path,
            audio_title: title,
            audioBackgroundImage: {
              background_type: background_type || "gradient",
              background_value: background_value || "{}",
              id: props.content_id,
              image_id,
              post_id,
            },
            id: props.content_id,
            selectedCollaborator: [],
          }}
          isViewOnly={false}
        />
      );
    case "poll":
      return (
        <PollContent
          isWithinRepostModal={true}
          onOptionClick={() => {}}
          pollData={{
            ...(props.content_data as ArticleProps.PollContentData),
            active: false,
            poll_interaction_user_voted: true,
            votes: {},
            leading_choice: "",
            total_votes: 0,
            user_voted_choice: "",
            choice_1_votes: 0,
            choice_2_votes: 0,
            choice_3_votes: 0,
            choice_4_votes: 0,
            choice_5_votes: 0,
            choice_6_votes: 0,
            choice_7_votes: 0,
            choice_8_votes: 0,
            choice_9_votes: 0,
            choice_10_votes: 0,
          }}
        />
      );
    case "rating":
      return (
        <RateContent
          isWithinRepostModal={true}
          onRatingSubmit={() => {}}
          rating={{
            ...(props.content_data as ArticleProps.RatingContentData),
            users_profile_pictures: [],
            user_median_votes: {
              average_score: 0,
              latest_users: [],
              total_votes: 0,
              more_user_count: 0,
            },
          }}
        />
      );
    case "text":
      const { content_data, topic_meta } =
        props as ArticleProps.WithTextContent;
      return (
        <TextContent
          blueprint={content_data.Blueprint}
          topic_meta={topic_meta}
        />
      );
    default:
      return null;
  }
};

const ArticleContent = () => {
  const { body_content } = useContext(ArticleCardContext);

  return (
    <Fragment>
      {body_content.map((content, i) => (
        <Fragment key={i}>{renderContent(content)}</Fragment>
      ))}
    </Fragment>
  );
};

export default ArticleContent;
